import type { LocalMessage } from "stream-chat";
import { ChatChannelType } from "../models/ChatChannel";

/**
 * Messages from users blocked by the current user are hidden in group and event chats.
 * DMs are handled by Stream itself; own messages and system messages are never hidden.
 */
export function isMessageFromBlockedUser(
    message: Pick<LocalMessage, 'type' | 'user'> | undefined,
    channelType: string | undefined,
    currentUserId: string | undefined,
    blockedUserIds: ReadonlySet<string>,
): boolean {
    if(!message || blockedUserIds.size === 0) return false;
    if(!channelType || channelType === ChatChannelType.Messaging) return false;
    if(message.type === 'system') return false;

    const authorId = message.user?.id;
    if(!authorId || authorId === currentUserId) return false;

    return blockedUserIds.has(authorId);
}
